import { useState, useEffect, useCallback } from "react";
import { getAllArticles, getArticleBySlug } from "@/api/articlesApi";

export const useArticles = (slug) => {
  const [articles, setArticles] = useState([]);
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllArticles = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getAllArticles();
      setArticles(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchArticleBySlug = useCallback(async (articleSlug) => {
    try {
      setLoading(true);
      const data = await getArticleBySlug(articleSlug);
      setArticle(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (slug) {
      fetchArticleBySlug(slug);
    } else {
      fetchAllArticles();
    }
  }, [slug, fetchAllArticles, fetchArticleBySlug]);

  return { articles, article, loading, error };
};
